import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiService } from '@workflow-admin/shared/data-access';
import {
  Field, WorkflowAction,
  WorkflowForm,
  WorkflowFormRequest,
  WorkflowInput
} from '@workflow-admin/shared/workflow/utils/workflow';


@Injectable({
  providedIn: 'root'
})
export class FormsApiService {

  baseUrl = this.apiService.apiUrl

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getForms(): Observable<WorkflowForm[]> {
    return this.http.get<WorkflowForm[]>(`${this.baseUrl}/forms`).pipe(
      map(response => response['hydra:member']),
      catchError(this.handleError)
    );
  }

  getForm(id: string): Observable<WorkflowForm>{
    return this.http.get<WorkflowForm>(`${this.baseUrl}/forms/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  createForm(form: WorkflowFormRequest): Observable<WorkflowForm> {
    return this.http.post<WorkflowForm>(`${this.baseUrl}/forms`, form).pipe(
      catchError(this.handleError)
    )
  }

  editForm(form: WorkflowFormRequest): Observable<WorkflowForm> {
    return this.http.put<WorkflowForm>(`${this.baseUrl}/forms/${form.uuid}`, form).pipe(
      catchError(this.handleError)
    )
  }

  deleteForm(id: string) {
    return this.http.delete(`${this.baseUrl}/forms/${id}`).pipe(
      catchError(this.handleError)
    )
  }

  createQuestion(question: Field): Observable<Field> {
    return this.http.post<Field>(`${this.baseUrl}/fields`, question).pipe(
      catchError(this.handleError)
    )
  }

  editQuestion(updateQuestion: Partial<Field>): Observable<Field> {
    return this.http.put<Field>(`${this.baseUrl}/fields/${updateQuestion.uuid}`, updateQuestion).pipe(
      catchError(this.handleError)
    )
  }

  deleteQuestion(id: string) {
    return this.http.delete(`${this.baseUrl}/fields/${id}`).pipe(
      catchError(this.handleError)
    )
  }

  getFormsForWorkflow(id: string): Observable<WorkflowInput[]> {
    return this.http.get<WorkflowInput[]>(`${this.baseUrl}/workflows/${id}/forms`).pipe(
      map(response => response['hydra:member']),
      catchError(this.handleError)
    )
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
